/**
 * CarePlanDialog - Add Care Plan Dialog Component
 * Extracted from ClientDetailPage
 */
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

export function CarePlanDialog({
  open,
  onOpenChange,
  clientName,
  newCarePlan,
  setNewCarePlan,
  saving,
  onSave,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Add Care Plan</DialogTitle>
          <DialogDescription>
            Create a new care plan for {clientName}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="plan-title">Title *</Label>
            <input
              id="plan-title"
              className="w-full px-3 py-2 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/50"
              placeholder="e.g., Personal Care Assistance"
              value={newCarePlan.title}
              onChange={(e) => setNewCarePlan(prev => ({ ...prev, title: e.target.value }))}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="plan-goals">Goals *</Label>
            <Textarea
              id="plan-goals"
              placeholder="What are the care goals?"
              value={newCarePlan.goals}
              onChange={(e) => setNewCarePlan(prev => ({ ...prev, goals: e.target.value }))}
              rows={3}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="plan-interventions">Interventions</Label>
            <Textarea
              id="plan-interventions"
              placeholder="What interventions will be performed?"
              value={newCarePlan.interventions}
              onChange={(e) => setNewCarePlan(prev => ({ ...prev, interventions: e.target.value }))}
              rows={3}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="plan-frequency">Frequency</Label>
            <input
              id="plan-frequency"
              className="w-full px-3 py-2 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/50"
              placeholder="e.g., 3x per week"
              value={newCarePlan.frequency}
              onChange={(e) => setNewCarePlan(prev => ({ ...prev, frequency: e.target.value }))}
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={onSave} disabled={saving}>
            {saving ? "Saving..." : "Create Care Plan"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
